import { AlertTriangle, ShieldX, Trash2, KeyRound, Globe } from 'lucide-react';
import { Card } from '../ui/card';

const Stat = ({ icon: Icon, label, value, hint, alert, testId, onClick }) => (
  <Card
    onClick={onClick}
    className={`p-4 transition-colors ${onClick ? 'cursor-pointer hover:border-slate-400' : ''} ${alert ? 'border-red-300 bg-red-50' : ''}`}
    data-testid={testId}
  >
    <div className="flex items-center gap-2 text-xs font-medium text-slate-500">
      <Icon className={`w-4 h-4 ${alert ? 'text-red-600' : 'text-slate-400'}`} /> {label}
    </div>
    <div className={`text-3xl font-bold mt-2 ${alert ? 'text-red-700' : 'text-slate-800'}`}>{value}</div>
    {hint && <div className="text-xs text-slate-500 mt-1 truncate">{hint}</div>}
  </Card>
);

export const SecuritySummaryCards = ({ summary, onPick }) => {
  if (!summary) return null;
  const topIp = summary.topFailedIps24h?.[0];
  return (
    <div className="space-y-3" data-testid="security-summary">
      <div className="grid grid-cols-2 lg:grid-cols-5 gap-3">
        <Stat icon={ShieldX} label="Failed logins (24h)" value={summary.failedLogins24h} alert={summary.failedLogins24h >= 10}
          hint={topIp ? `Most from ${topIp.ip}` : 'None'} testId="card-failed-logins" onClick={() => onPick({ category: 'failed_logins', since: summary.dayAgo, sinceLabel: 'Last 24 hours' })} />
        <Stat icon={AlertTriangle} label="Locked right now" value={summary.lockedAccountsNow} alert={summary.lockedAccountsNow > 0}
          hint="Too many wrong passwords" testId="card-locked" />
        <Stat icon={Trash2} label="Deletions (7 days)" value={summary.destructive7d} alert={summary.destructive7d > 0}
          hint="Wipes, companies, banks, users" testId="card-destructive" onClick={() => onPick({ category: 'destructive', since: summary.weekAgo, sinceLabel: 'Last 7 days' })} />
        <Stat icon={KeyRound} label="Password / PIN changes (7d)" value={summary.credentialChanges7d} alert={summary.credentialChanges7d > 0}
          hint="Check these were you" testId="card-credentials" onClick={() => onPick({ category: 'credentials', since: summary.weekAgo, sinceLabel: 'Last 7 days' })} />
        <Stat icon={Globe} label="New sign-in IPs (24h)" value={summary.newIps24h?.length || 0} alert={(summary.newIps24h?.length || 0) > 0}
          hint={summary.newIps24h?.length ? 'IPs listed below' : 'None'} testId="card-new-ips" />
      </div>
      {summary.newIps24h?.length > 0 && (
        <div className="flex flex-wrap items-center gap-2 text-xs" data-testid="new-ips">
          <span className="text-slate-500">First-time sign-in IPs (24h):</span>
          {summary.newIps24h.map((ip) => (
            <button key={ip} onClick={() => onPick({ ip })} data-testid={`new-ip-${ip}`}
              className="link-chip px-2 py-1 rounded-full bg-amber-100 text-amber-800 hover:bg-amber-200 font-mono transition-colors">
              {ip}
            </button>
          ))}
        </div>
      )}
      {summary.topFailedIps24h?.length > 0 && (
        <div className="flex flex-wrap items-center gap-2 text-xs" data-testid="top-failed-ips">
          <span className="text-slate-500">Failed logins by IP (24h):</span>
          {summary.topFailedIps24h.map((t) => (
            <button key={t.ip} onClick={() => onPick({ ip: t.ip, category: 'failed_logins', since: summary.dayAgo, sinceLabel: 'Last 24 hours' })} data-testid={`top-ip-${t.ip}`}
              className="link-chip px-2 py-1 rounded-full bg-red-100 text-red-800 hover:bg-red-200 font-mono transition-colors"
              title={`Usernames tried: ${t.users.join(', ')}`}>
              {t.ip} · {t.count}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
